<template>
  <div
    :id="id"
    class="element marquee draggable"
    :class="[
      cssClasses,
      animationInStyle,
      animationOutStyle,
      { selected: isSelected, locked },
    ]"
    :style="[basicStyles, transformStyles]"
  >
    <transition
      :enter-active-class="'animated ' + animationIn"
      :leave-active-class="'animated ' + animationOut"
      :duration="{ leave: leaveDuration }"
      mode=""
      @after-enter="afterEnter"
      @before-leave="beforeLeave"
    >
      <div
        v-show="toggle"
        class="marquee-wrap"
        :data-test-image-optimized="backgroundMetaOptimizeApplied"
        :class="[loopingClass, alignItemsClass]"
        :style="[
          animationStyles,
          borderRadiusStyles,
          backgroundStyles,
          borderStyles,
          boxShadowStyles,
        ]"
      >
        <marquee
          :animate="tickerPreviewing"
          :speed="scrollSpeed"
          :paused="false"
          :reverse="element.reverse"
          :item-gap="styles.gap + 'px'"
          :animation-iteration-count="`infinite`"
          :space-between="spaceBetweenWidth"
        >
          <!-- a case where we don't want to reverse the child elements because they are inline -->
          <element-renderer
            v-for="elementId in childElements"
            v-show="!getElementById(elementId)?.layerHiddenInGraphics"
            :id="elementId"
            :key="elementId"
            :type="getElementValueByProp(elementId, 'type')"
            :parent="id"
            :toggle="toggle"
          />

          <!-- the repeated elements -->
          <template v-for="elements in virtualElements">
            <element-renderer
              v-for="e in elements"
              v-show="!getElementById(e)?.layerHiddenInGraphics"
              :id="e"
              :key="e"
              ref="children"
              :group="group"
              :type="getElementValueByProp(e, 'type')"
              :parent="parent"
              :toggle="toggle"
            />
          </template>
        </marquee>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { defineAsyncComponent } from 'vue';
import Marquee from '../../Embeds/Marquee.vue';
import ElementsMixins from '../../../mixins/elements-mixins';
import MoveMixins from '../../../mixins/move-mixins';
import ResizeMixins from '../../../mixins/resize-mixins';
import DataRepeaterMixins from '../../../mixins/data-repeater-mixins';

export default {
  name: 'MarqueeWrapper',
  components: {
    ElementRenderer: defineAsyncComponent(() => import('../ElementRenderer')),
    Marquee,
  },
  mixins: [ElementsMixins, ResizeMixins, MoveMixins, DataRepeaterMixins],
  computed: {
    ...mapGetters([
      'isPreviewingTicker',
    ]),
    scrollSpeed() {
      return this.element.speed;
    },
    spaceBetween() {
      if (this.element.tickerSpacing === 'spaced') {
        return true;
      }
      return false;
    },
    tickerPreviewing: {
      get() {
        return this.isPreviewingTicker(this.element.id);
      },
      set() {
        this.updateTickerPreviewing(this.element.id);
      },
    },
    spaceBetweenWidth() {
      if (this.spaceBetween) {
        return this.styles.width - this.styles.gap;
      }

      return null;
    },
    childElements() {
      // a case where we don't want to reverse the child elements because they are inline
      return [...this.getElementGroupMap[this.id]];
    },
    alignItemsClass() {
      switch (this.verticalAlign) {
        case 'top':
          return 'align-items-start';
        case 'middle':
          return 'align-items-center';
        case 'bottom':
          return 'align-items-end';
        default:
          return '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
